import {Tab} from "@headlessui/react";
import {useTranslation} from "next-i18next";
import React, {ReactNode, useState} from "react";
import ObjectDetails from "./ObjectDetails";
import Prices from "./Prices";
import WeitereLeistungen from "./WeitereLeistungen";
import {ObjectInterfaceWithCity} from "../../interfaces/ObjectInterface";
import BookingCalendar from './BookingCalendar';

export type VermietungIcon = {
	name: string;
	icon: ReactNode;
};

interface VermietungsDetailedTabGroupProps {
	object: ObjectInterfaceWithCity;
	bookedDates?: { start: Date; end: Date }[];
	locale?: string;
	startDate?: Date | null;
	endDate?: Date | null;
}

enum TabsEnum {
	OBJECTDETAILS,
	PRICES,
	SERVICES
}

const VermietungsDetailedTabGroup = ({object, bookedDates, locale, startDate, endDate}: VermietungsDetailedTabGroupProps) => {
	const [selectedTab, setSelectedTab] = useState<TabsEnum>(TabsEnum.OBJECTDETAILS);

	const {t} = useTranslation();

	const tabs = [
		"components.vermietungsDetailedTabGroup.objectDetails",
		"components.vermietungsDetailedTabGroup.prices",
		"components.vermietungsDetailedTabGroup.additionalServices"
	];

	return (
		<div className="">
			<div className="">
				<Tab.Group
					selectedIndex={selectedTab}
					onChange={(value) => setSelectedTab(value)}
				>
					<Tab.List className={`w-full flex justify-around md:max-w-xl`}>
						{tabs.map((tab) => (
							<Tab
								key={tab}
								className={`${selectedTab === tabs.indexOf(tab) ? "bg-white text-black" : "bg-leo-light-gray"} w-full py-4 lg:min-w-[220px] uppercase outline-none mr-2 text-[12px] font-bold rounded-tl-[20px] rounded-tr-[20px] shadow-[0px_1px_6px_rgba(0,0,0,0.1607843137)] hide-bottom-shadow`}>
								{t(tab)}
							</Tab>
						))}
					</Tab.List>
					<Tab.Panels className="shadow-[0px_1px_6px_rgba(0,0,0,0.1607843137)] rounded-bl-[20px] rounded-br-[20px] rounded-tr-[20px] px-4 pt-4 pb-10 lg:px-10 lg:pt-10 lg:pb-16">
						<Tab.Panel>
							<ObjectDetails object={object} bookedDates={bookedDates}
							               locale={locale}
							               location={`${object?.cityOfObject?.name}, ${object?.cityOfObject?.province?.name}`}
							               startDate={startDate}
							               endDate={endDate}/>
						</Tab.Panel>
						<Tab.Panel>
							<Prices object={object}/>
						</Tab.Panel>
						<Tab.Panel>
							<WeitereLeistungen object={object}/>
						</Tab.Panel>
					</Tab.Panels>
				</Tab.Group>
			</div>
		</div>
	);
}

export default VermietungsDetailedTabGroup;
